// extracted by mini-css-extract-plugin
module.exports = {"space":"Particles_space__g34sU","particle":"Particles_particle__SRTWG","particles":"Particles_particles__e98tU"};